// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__37jsS","topBottomGutter":"Layout_topBottomGutter__VWd66"};